// import debounce function
import debounce from 'lodash/debounce';

/**
 * Generic event for multiple actions
 */
function doAction(e) {
	let targetElement = document.getElementById(e.target.getAttribute("data-target"));

	// toggle toggleable if clicked
	if (e.target.getAttribute("data-target").includes("--toggleable")) {
		targetElement.classList.toggle("toggled");
	}

	// hideSelf if class present
	if (e.target.classList.contains('clickHideSelf')) {
		e.target.classList.toggle("hidden");
	}

	// show bookViewing form on click
	if (e.target.getAttribute("data-target") === "bookViewing") {
		targetElement.classList.remove("hidden");
	}
	// show listingAccess form popup on click
	if (e.target.getAttribute("data-target") === "listingAccess" || e.target.id === "listingAccess") {
		// check if sessionstorage is set from previously sent in form to gain access
		if ( sessionStorage.getItem(document.body.getAttribute("data-id")) == null || e.target.classList.contains("active") ) {
			// if not, we prevent common action of download
			e.preventDefault();
			// if self, do self
			if (e.target.id === "listingAccess") {
				e.target.classList.toggle("active");
			} else {
				targetElement.classList.toggle("active");
			}
			// don't scroll behind popup
			document.body.classList.toggle("overflow-hidden");
		}
	}
	// show IssuuFrame popup on click
	if (e.target.getAttribute("data-target") === "listingIssuu" || e.target.id === "listingIssuu") {

		// if not, we prevent common action of download
		e.preventDefault();
		// if self, do self
		if (e.target.id === "listingIssuu") {
			e.target.classList.toggle("active");
		} else {
			targetElement.classList.toggle("active");
		}
		// don't scroll behind popup
		document.body.classList.toggle("overflow-hidden");
	}
	// show content popup on click
	if (e.target.getAttribute("data-target") === "contentPopup" || e.target.id === "contentPopup") {

		// if not, we prevent common action of download
		e.preventDefault();
		// if self, do self
		if (e.target.id === "contentPopup") {
			e.target.classList.toggle("active");
		} else {
			targetElement.classList.toggle("active");
		}
		// don't scroll behind popup
		document.body.classList.toggle("overflow-hidden");
	}
}

/**
 * Initiate custom selects on items with class customSelect
 * @type {[NodeList]}
 */
setTimeout(function() {
	let clickables = document.querySelectorAll('.clickEvent');
	if (clickables.length > 0) {
	  clickables.forEach(function(element, index) {
		element.addEventListener('click', doAction);
	  });
	}
}, 200);

/*
 * set css variable depending on scroll up/down to accommodate for browser bars
 */
var lastScrollTop = 0;
const scrollDirection = () => {
	var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
	if (st > lastScrollTop){
		document.documentElement.style.setProperty('--scroll-padding', 0 + "px");
	} else {
		document.documentElement.style.setProperty('--scroll-padding', 96 + "px");
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
// Listen for new scroll events, here we debounce our `scrollDirection` function
document.addEventListener('scroll', debounce(scrollDirection, 200), {passive: true});
